import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-monetary-value',
  templateUrl: './monetary-value.component.html',
  styleUrls: ['./monetary-value.component.scss'],
  standalone: true
})
export class MonetaryValueComponent {
  private valueBacking;
  @Input()
  public set value(value1: number) {
    this.valueBacking = value1;
    this.isNegative = value1 < 0;
    const formattedValue = Math.abs(value1).toFixed(2);
    const parts = formattedValue.split('.');
    this.leftPart = parts[0];
    this.rightPart = parts[1];
  }
  public get value(): number {
    return this.valueBacking;
  }
  leftPart: string;
  rightPart: string;
  isNegative: boolean;
}
